import { render } from "./AdminEditProfile.vue?vue&type=template&id=5510375b&lang=pug"
import script from "./AdminEditProfile.vue?vue&type=script&lang=js"
export * from "./AdminEditProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__